<template>
  <div id="container">
    <div id="content-wrap">
      <NavBar :mobile="isMobile" :info="info"/>
      <router-view class="router-view" :mobile="isMobile" :info="info"/>
    </div>
    <Footer :mobile="isMobile" :info="info"/>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';
export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  },
  data: () => {
    return {
      isMobile,
      windowWidth: window.innerWidth,
      info: {
        ioS: false,
        name: 'ProSource Supply',
        yelp: 'https://www.yelp.com/biz/prosource-supply-los-angeles-2',
        map: 'https://maps.google.com/maps?q=prosource%20supply%20&t=&z=13&ie=UTF8&iwloc=&output=embed',
        directions: 'https://www.google.com/maps/dir//21300+Superior+St,+Chatsworth,+CA+91311/@34.1448745,-118.5154596,11z/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x80c29cbd8f0d72a5:0x30b5b0656b1fcdc1!3e0',
        email: 'office@prosourceins.com',
        mail: 'mailto:office@prosourceins.com',
        address: '21300 Superior St, CA 91311',
        tel: 'tel:+18003877698',
        phone: '1-800-387-7698',
        logo: 'logo.png',
        logoWhite: 'logo-white.png',
        yelpLogo: 'yelp.png',
        googleLogo: 'google.png'
      }
    }
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
     this.windowWidth = newWidth
     console.log(this.windowWidth)
     this.isMobile = this.windowWidth < 910 ? true : false
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.isMobile = window.innerWidth < 910 ? true : false
    this.info.ioS = ['iPad Simulator','iPhone Simulator','iPod Simulator','iPad', 'iPhone','iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    
    console.log('IOS: ', this.info.ioS)
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },

  methods: {  
    onResize() {
      this.windowWidth = window.innerWidth
    }
  }
};
</script>

<style>
html {
  background: #fff;
  margin: 0;
}
#container {
  font-family: 'Lato', sans-serif;
  font-family: 'Raleway', sans-serif;
font-family: 'Open Sans', sans-serif;

  font-weight: 300;
  font-style: normal;
  position: relative;
  min-height: 100vh;
}
#content-wrap {
  padding-bottom: 3.5rem;    /* Footer height */
}
#footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 3.5rem;    /* Footer height */
}
.ps-blue, a {
  color: #0f376f;
}

.bg-ps-blue {
  background: #0f376f;
}
</style>